import {
  showNotification,
  getNotificationBuilder,
  getToastBuilder,
  ToastButton,
  NotificationType,
} from '@genesislcap/foundation-notifications';

export enum ToastType {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum ButtonAppearance {
  PRIMARY = 'primary-toast',
  SECONDARY = 'secondary-toast',
}

export type ActionButton = {
  name: string;
  buttonAppearance: ButtonAppearance;
  isdismiss?: boolean;
  clickAction: () => void;
};

const notifyBase = (
  header: string,
  content = ' ',
  date = '',
  type: NotificationType = null,
  timeout: number = 15_000,
  buttons: ToastButton[] = []
) => {
  showNotification(
    getNotificationBuilder()
      .withTitle(header)
      .withBody(content)
      .withToast(
        getToastBuilder()
          .withDetails(null)
          .withType(type)
          .withButtons(buttons)
          .withAutoClose(!!timeout)
          .withCloseTimeout(timeout)
          .build()
      )
      .build(),
    'zero-notification-listener',
    null
  );
};

export const notify = (
  header: string,
  message = ' ',
  date = '',
  timeout?: number,
  actions?: ToastButton[]
) => {
  return notifyBase(header, message, date, ToastType.SUCCESS, timeout, actions);
};

export const notifyWarning = (
  header: string,
  message = ' ',
  date = '',
  timeout?: number,
  actions?: ToastButton[]
) => {
  return notifyBase(header, message, date, ToastType.WARNING, timeout, actions);
};

export const notifyError = (
  header: string,
  message = ' ',
  date = '',
  timeout?: number,
  actions?: ToastButton[]
) => {
  return notifyBase(header, message, date, ToastType.ERROR, timeout, actions);
};
